(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
/* ── StickyHeader (web component Dawn — ES5 prototype) ─── */
function StickyHeader() {
  return Reflect.construct(HTMLElement, [], StickyHeader);
}
Object.setPrototypeOf(StickyHeader.prototype, HTMLElement.prototype);
Object.setPrototypeOf(StickyHeader, HTMLElement);

StickyHeader.prototype.connectedCallback = function() {
  this.header = document.querySelector('.section-header');
  this.headerIsAlwaysSticky =
    this.getAttribute('data-sticky-type') === 'always' ||
    this.getAttribute('data-sticky-type') === 'reduce-logo-size';
  this.headerBounds = {};
  this.setHeaderHeight();
  window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
  if (this.headerIsAlwaysSticky) {
    this.header.classList.add('shopify-section-header-sticky');
  }
  this.currentScrollTop = 0;
  this.preventReveal    = false;
  this.predictiveSearch = this.querySelector('predictive-search');
  this.onScrollHandler  = this.onScroll.bind(this);
  var self = this;
  this.hideHeaderOnScrollUp = function() { self.preventReveal = true; };
  this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  window.addEventListener('scroll', this.onScrollHandler, false);
  this.createObserver();
};

StickyHeader.prototype.setHeaderHeight = function() {
  document.documentElement.style.setProperty(
    '--header-height', this.getBoundingClientRect().height + 'px'
  );
};

StickyHeader.prototype.disconnectedCallback = function() {
  window.removeEventListener('scroll', this.onScrollHandler);
};

StickyHeader.prototype.createObserver = function() {
  var observer = new IntersectionObserver(function(entries) {
    this.headerBounds = entries[0].intersectionRect;
    observer.disconnect();
  }.bind(this));
  observer.observe(this);
};

StickyHeader.prototype.onScroll = function() {
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
  if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
    if (this.preventReveal) {
      window.clearTimeout(this.deferredRevealTimeout);
      this.deferredRevealTimeout = window.setTimeout(function() {
        this.preventReveal = false;
      }.bind(this), 66);
      this.currentScrollTop = scrollTop;
      return;
    }
    requestAnimationFrame(this.hide.bind(this));
  } else if (scrollTop < this.currentScrollTop && scrollTop < this.headerBounds.top) {
    requestAnimationFrame(this.reveal.bind(this));
  }
  this.currentScrollTop = scrollTop;
};

StickyHeader.prototype.hide = function() {
  if (!this.headerIsAlwaysSticky) {
    this.header.classList.add('shopify-section-header-hidden');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }
};

StickyHeader.prototype.reveal = function() {
  this.header.classList.add('shopify-section-header-sticky', 'animate');
  this.header.classList.remove('shopify-section-header-hidden');
};

StickyHeader.prototype.closeMenuDisclosure = function() {
  this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
  this.disclosures.forEach(function(d) { d.onFocusOut(); });
};

StickyHeader.prototype.closeSearchModal = function() {
  this.searchModal = this.searchModal || this.header.querySelector('details-modal');
  if (this.searchModal) this.searchModal.onFocusOut();
};

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();
})();
